import type { ColorStyle, ColorStyles } from './styleMapElement';

type ColorOptions = {
  // TODO: color for an element that is initiating the calculation
  // initiatingElement: string
  selectedElement: string;
  subnet: string;
};

export function createColorStyles(colorOptions: ColorOptions): ColorStyles {
  const selectedPoint: ColorStyle = {
    radius: 11,
    color: colorOptions.selectedElement,
    fillColor: '#ffffff',
    fillOpacity: 1,
    weight: 3
  };
  const selectedLine: ColorStyle = {
    color: colorOptions.selectedElement,
    fillColor: colorOptions.selectedElement,
    fillOpacity: 1,
    weight: 10
  };
  const subnetPointLine: ColorStyle = {
    color: colorOptions.subnet,
    fillColor: colorOptions.subnet,
    fillOpacity: 1,
    weight: 2,
    radius: 5
  };
  return {
    selectedPoint,
    selectedLine,
    selectedArea: {
      ...selectedPoint,
      fillOpacity: 0.5,
      weight: 5
    },
    subnetPointLine,
    subnetArea: {
      ...subnetPointLine,
      fillOpacity: 0.5
    }
  };
}
